import request from '@/utils/request';
import Resource from '@/api/resource';
class AdvResource extends Resource {
  constructor() {
    super('adv');
  }

  /** 获取渠道分类接口 */
  getChannelTypeApi(data) {
    return request({
      url: `/${this.uri}/getChannelType`,
      method: 'get',
      params: data,
    });
  }

  /** 获取投放系统素材列表接口 */
  getAvdMaterialApi(data) {
    return request({
      url: `/${this.uri}/material`,
      method: 'get',
      params: data,
    });
  }
}
export { AdvResource as default };
